import { apiService } from "../api.service";
export const verifyPasswordResetRequest = async (token: string) => {
  return apiService.apiRequest<any>("post", `auth/verify-reset-token`, {
    token,
  });
};
